import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors, thematicColors, theme } from '@revenuemarket/design';
import { Typography } from '@revenuemarket/ui';

export const DecorationImage = styled.img`
  display: block;
  width: 228px;
  margin: 0 auto;
  @media (max-width: 500px) {
    width: 142px;
  }
`;

export const InputFieldWrapper = styled.span<{ hasValue: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;

  svg {
    display: inline;
  }

  .input-wrapper {
    background: transparent;
    border: 1px solid ${colors.grayscale200};

    &.error {
      border-color: ${theme.semanticColors.danger.regular};
    }

    &.right {
      position: relative;

      input {
        padding-right: 28px;
      }

      &::after {
        color: black;
        position: absolute;
        top: 10px;
        right: 12px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        content: '원';
        color: ${({ hasValue }) => (hasValue ? 'black' : colors.grayscale450)};
      }
    }

    input.right {
      text-align: right;
    }
  }
`;
export const Form = styled.form`
  width: 375px;
  margin: 0 auto;

  @media (max-width: 500px) {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
  }

  ${InputFieldWrapper} + ${InputFieldWrapper} {
    margin-top: 24px;
  }
`;

export const Label = styled(Typography)<{ required: boolean }>`
  display: flex;
  gap: 2px;
  align-items: center;
  ${({ required }) =>
    required &&
    css`
      &:after {
        content: '*';
        color: ${thematicColors.primary.regular};
      }
    `}
  margin-bottom: 4px;
`;

export const CheckboxWrapper = styled.div`
  margin-top: 48px;
`;

export const Button = styled.button`
  display: flex;
  height: 48px;
  width: 100%;
  padding: 12px 20px;
  margin-top: 48px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: linear-gradient(90deg, #949ff9 0%, #4ec9c3 100%);
`;
